export default "__VITE_ASSET__01ced370__"